import { TimelineElement } from '@/types';
import React from 'react';
import TimelineComponent from '@components/Timeline';

interface Props {
  timeline_elements: TimelineElement[];
  blocktitle?: string;
  blocktext?: string;
}

function Timeline(props: Props) {
  const { timeline_elements: timelineElements, blocktitle, blocktext } = props;

  return (
    <section className='timeline'>
      <div className='streamfield'>
        <div className='timeline__header'>
          {blocktitle ? <h2 className='timeline__title'>{blocktitle}</h2> : ''}
          {blocktext ? <div className='timeline__description'>{blocktext}</div> : ''}
        </div>
        <TimelineComponent timeline_elements={timelineElements} />
      </div>
    </section>
  );
}

export default Timeline;
